// extracted by mini-css-extract-plugin
module.exports = {"policyWrapper":"PrivacyPolicy_policyWrapper__3zjNl","policyInnerWrapper":"PrivacyPolicy_policyInnerWrapper__jaWX7","policySection":"PrivacyPolicy_policySection__RMstU"};